// Longer timeout for RPC requests because of AI API
export const REQUEST_TIMEOUT = 15000;